<logzy-content-loader [set3]="loader" *ngIf="loader"></logzy-content-loader>
<ng-container>
  <div class="vstack">
    <div class="HeaderSet">
      <span class="editHead editHeadCursor" (click)="leaseDetailsExpand = !leaseDetailsExpand">
        Lease Contract Details
        <i class="flaticon-down-chevron" [ngClass]="leaseDetailsExpand? 'more':'' "></i>
      </span>
    </div>
    <div class="additionalDetails" [class.viewExpand]="leaseDetailsExpand">
      <div class="content " id="card1" fxLayout="row wrap" fxFlex="100" [class.d-none]="loader">
        <div class="inputs " fxLayout="row wrap">
          <div class="infoBox">
            <span class=" infoBoxTitle">PARTY DETAILS</span>
            <app-text-field [label]="'Lessor Company*'" [(ngModel)]="requestDetails.lease_agreement.lessor_company_name"
              [isEditable]="isEditable" class="align-items-center email" placeholder="Lessor Company" fxFlex="12.3em"
              fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessor_company_name"></app-text-field>

            <app-text-field [label]="'Lessor Address*'"
              [(ngModel)]="requestDetails.lease_agreement.lessor_company_address" [isEditable]="isEditable"
              [isMultiline]="true" class="align-items-center email" placeholder="Lessor Address*" fxFlex="12.3em"
              fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessor_company_address"></app-text-field>


            <app-text-field [label]="'Lessor Contact Person*'"
              [(ngModel)]="requestDetails.lease_agreement.lessor_contact_person_name" [isEditable]="isEditable"
              class="align-items-center email" placeholder="Lessor Contact Details" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessor_contact_person_name"></app-text-field>

            <app-text-field label="Lessor Contact Person Email*"
              [(ngModel)]="requestDetails.lease_agreement.lessor_contact_person_email" [isEditable]="isEditable"
              [name]="'remarks'" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessor_contact_person_email">
            </app-text-field>
            <app-text-field label="Lessor Contact Person Phone*"
              [(ngModel)]="requestDetails.lease_agreement.lessor_contact_person_phone" [isEditable]="isEditable"
              [name]="'remarks'" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessor_contact_person_phone">
            </app-text-field>

            <app-text-field [label]="'Lessee Company*'" [(ngModel)]="requestDetails.lease_agreement.lessee_company_name"
              [isEditable]="isEditable" class="align-items-center email" placeholder="Lessee Company" fxFlex="12.3em"
              fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessee_company_name"></app-text-field>


            <app-text-field [label]="'Lessee Address*'"
              [(ngModel)]="requestDetails.lease_agreement.lessee_company_address" [isEditable]="isEditable"
              [isMultiline]="true" class="align-items-center email" placeholder="Lessee Address" fxFlex="12.3em"
              fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessee_company_address"></app-text-field>

            <app-text-field [label]="'Lessee Contact Person*'"
              [(ngModel)]="requestDetails.lease_agreement.lessee_contact_person_name" [isEditable]="isEditable"
              class="align-items-center email" placeholder="Lessee Contact Details" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessee_contact_person_name"></app-text-field>

            <app-text-field label="Lessee Contact Person Email*"
              [(ngModel)]="requestDetails.lease_agreement.lessee_contact_person_email" [isEditable]="isEditable"
              [name]="'remarks'" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessee_contact_person_email">
            </app-text-field>
            <app-text-field label="Lessee Contact Person Phone*"
              [(ngModel)]="requestDetails.lease_agreement.lessee_contact_person_phone" [isEditable]="isEditable"
              [name]="'remarks'" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lessee_contact_person_phone">
            </app-text-field>
          </div>
          <div class="infoBox">
            <span class=" infoBoxTitle">BILLING DETAILS</span>
            <app-mat-auto-search [label]="'Type of Lease*'" [(ngModel)]="requestDetails?.lease_agreement.lease_type"
              [options]="dd_leaseOptions?.actions?.POST?.lease_type.choices" [isEditable]="isEditable" [idField]="null"
              [displayField]="'display_name'" [name]="'request_source'" [searchable]="true" [clearable]="true"
              fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lease_type"></app-mat-auto-search>

            <app-mat-auto-search [label]="'Billing Cycle*'" [(ngModel)]="requestDetails?.lease_agreement.billing_cycle"
              [options]="dd_leaseOptions?.actions?.POST?.billing_cycle?.choices" [isEditable]="isEditable"
              [idField]="null" [displayField]="'display_name'" [name]="'request_source'" [searchable]="false"
              [clearable]="false" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.billing_cycle"></app-mat-auto-search>

            <app-mat-auto-search [label]="'Billing Date*'" [(ngModel)]="requestDetails?.lease_agreement.billing_date"
              [options]="dd_leaseOptions?.actions?.POST?.billing_date?.choices" [isEditable]="isEditable"
              [idField]="null" [displayField]="'display_name'" [name]="'request_source'" [searchable]="false"
              [clearable]="false" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.billing_date"></app-mat-auto-search>

            <logzy-money-field [label]="'Security Deposit'"
              [(amount)]="requestDetails?.lease_agreement.security_deposit"
              [(currencyCode)]="requestDetails?.lease_agreement.security_deposit_currency" [isEditable]="isEditable"
              fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.security_deposit">
            </logzy-money-field>
          </div>
          <div class="infoBox">
            <span class=" infoBoxTitle">AGREEMENT DETAILS</span>
            <app-text-field [label]="'Agreement No*'" [(ngModel)]="requestDetails?.lease_agreement.agreement_number"
              [isEditable]="isEditable" class="align-items-center email" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.agreement_number"></app-text-field>

            <app-date-field [label]="'Lease Start Date'"
              [(ngModel)]="requestDetails?.lease_agreement.agreement_starts_from"
              (ngModelChange)="calculateLeaseAgreementDuration($event)" [isEditable]="isEditable" [name]="'remarks'"
              fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.agreement_starts_from">
            </app-date-field>

            <app-date-field [label]="'Lease End Date'" [(ngModel)]="requestDetails?.lease_agreement.agreement_ends_on"
              (ngModelChange)="calculateLeaseAgreementDurationEndDate()" [isEditable]="isEditable" [name]="'remarks'"
              [disabled]="requestDetails?.lease_agreement.agreement_starts_from == null"
              [minDate]="requestDetails?.lease_agreement.agreement_starts_from" fxFlex="12.3em"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.agreement_ends_on">
            </app-date-field>

            <app-text-field [label]="'Lease Agreement Duration'" [(ngModel)]="leaseAgreementDuration"
              [isEditable]="false" class="align-items-center email" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lease_agreement_duration"></app-text-field>

            <app-mat-auto-search [label]="'Currency'" [(ngModel)]=" requestDetails?.lease_agreement.currency"
              [listUrl]="currencyMaster_url+'currency/?currency_code=::search::'" [isEditable]="isEditable"
              [idField]="'currency_code'" [displayField]="'currency_code'" [name]="'currency'" [searchable]="true"
              [clearable]="false" fxFlex="12.3em" fxLayout="column" (change)="setDefaultCurrency($event)"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.currency"></app-mat-auto-search>

            <app-mat-auto-search [label]="'Lease Use'" [(ngModel)]="requestDetails?.lease_agreement.lease_purpose"
              [isEditable]="isEditable" [options]="dd_leaseUse?.results" [idField]="null" [displayField]="'value'"
              [name]="'request_source'" [searchable]="false" [clearable]="false" fxFlex="12.3em" fxLayout="column"
              [errors]="leaseQuoteService.baseQuote?.error.lease_agreement.lease_purpose"></app-mat-auto-search>

            <app-text-field [label]="'Remarks'" [(ngModel)]="requestDetails?.lease_agreement.remarks"
              [isMultiline]="true" [isEditable]="isEditable" class="align-items-center email" fxFlex="12.3em"
              fxLayout="column"></app-text-field>

            <app-text-field [label]="'Master Agreement No'"
              [(ngModel)]="requestDetails?.requestor?.company.master_agreement_no" [isEditable]="false"
              class="align-items-center email" fxFlex="12.3em" fxLayout="column"></app-text-field>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>